import { render, staticRenderFns } from "./PPool.vue?vue&type=template&id=27dd8d4a&scoped=true"
import script from "./PPool.vue?vue&type=script&lang=js"
export * from "./PPool.vue?vue&type=script&lang=js"
import style0 from "./PPool.vue?vue&type=style&index=0&id=27dd8d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd8d4a",
  null
  
)

export default component.exports